import _ from 'lodash'
import FileSaver from 'file-saver'
import moment from 'moment-timezone'

import api from '@/api/api'

import ScrollTo from '@/components/general/scroll-to/scroll-to'
import MenuMoreOptions from '@/components/general/menu-more-options/menu-more-options'
import TextField from '@/components/general/fields/text/text'
import SelectField from '@/components/general/fields/select/select'
import SearchField from '@/components/general/fields/search/search'
import CheckboxField from '@/components/general/fields/checkbox/checkbox'
import FileField from '@/components/general/fields/file/file'
import DateField from '@/components/general/fields/date/date'

export default {
  name: 'clients-list',
  data () {
    return {
      clients: [],
      menuOptions: [
        {
          iconClass: 'fa fa-chain',
          name: this.$t('private.clients.list.menu_more_options.associate_account'),
          action: 'associateAccount'
        },
        {
          iconClass: 'fa fa-list',
          name: this.$t('private.clients.list.menu_more_options.see_associated_accounts'),
          action: 'seeAssociatedAccounts'
        },
        {
          iconClass: 'fa fa-pencil',
          name: this.$t('private.clients.list.menu_more_options.edit_client'),
          action: 'edit'
        },
        {
          iconClass: 'fa fa-trash',
          name: this.$t('private.clients.list.menu_more_options.delete_client'),
          action: 'delete'
        }
      ],
      filters: {
        cif: {
          id: _.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.clients.list.filters.cif'),
          type: 'text',
          error: false,
          filters: {
            type: 'string',
            minLength: 2,
            maxLength: 100,
            required: true
          },
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        clientCode: {
          id: _.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.clients.list.filters.client_code'),
          type: 'text',
          error: false,
          filters: {
            maxLength: 8
          },
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        // email : {
        // 	id      : _.uniqueId('field_'),
        // 	display : true,
        // 	value   : '',
        // 	name    : this.$t('private.clients.list.filters.email'),
        // 	type    : 'email',
        // 	error   : false,
        // 	filters : {
        // 		type      : 'string',
        // 		minLength : 2,
        // 		maxLength : 100,
        // 		required  : true
        // 	}
        // },
        legalName: {
          id: _.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.clients.list.fields.legal_name'),
          type: 'text',
          error: false,
          filters: {
            type: 'string',
            minLength: 2,
            maxLength: 40,
            required: true
          },
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        ascending: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.clients.list.filters.sort_ascending'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.clients.list.filters.sort_options.created_at'),
            value: 'createdAt'
          }, {
            fakeValue: this.$t('private.clients.list.filters.sort_options.cif'),
            value: 'cif'
          }, {
            fakeValue: this.$t('private.clients.list.filters.sort_options.client_code'),
            value: 'clientCode'
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        descending: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: this.$t('private.clients.list.filters.sort_options.created_at'),
          value: 'createdAt',
          name: this.$t('private.clients.list.filters.sort_descending'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.clients.list.filters.sort_options.created_at'),
            value: 'createdAt'
          }, {
            fakeValue: this.$t('private.clients.list.filters.sort_options.cif'),
            value: 'cif'
          }, {
            fakeValue: this.$t('private.clients.list.filters.sort_options.client_code'),
            value: 'clientCode'
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        limit: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: this.$t('private.clients.list.filters.limit_options.10'),
          value: 10,
          name: this.$t('private.clients.list.filters.limit'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.clients.list.filters.limit_options.10'),
            value: 10
          }, {
            fakeValue: this.$t('private.clients.list.filters.limit_options.25'),
            value: 25
          }, {
            fakeValue: this.$t('private.clients.list.filters.limit_options.50'),
            value: 50
          }, {
            fakeValue: this.$t('private.clients.list.filters.limit_options.100'),
            value: 100
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        skip: {
          value: 0
        }
      },
      getClientsActive: false,
      activateFilters: false,
      haveData: false,
      nextPage: false,
      displayAssociateAccount: false,
      formAssociateAccount: {
        fields: {
          id: {
            value: '',
            filters: {
              type: 'string',
              required: true
            }
          },
          client: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.clients.list.associate_account_modal.fields.client'),
            error: false,
            active: false,
            options: [],
            filters: {
              type: 'string',
              required: true
            }
          },
          legalName: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.associate_account_modal.fields.legal_name'),
            type: 'text',
            disabled: true,
            error: false,
            filters: {}
          },
          cif: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.associate_account_modal.fields.cif'),
            type: 'text',
            disabled: true,
            error: false,
            filters: {}
          },
          email: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.associate_account_modal.fields.email'),
            type: 'email',
            disabled: true,
            error: false,
            filters: {}
          }
        },
        active: false
      },
      getSearchClientsForAssociated: false,
      formCreate: {
        fields: {
          seller: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.clients.list.fields.seller'),
            error: false,
            active: false,
            options: [],
            filters: {
              type: 'string',
              required: true
            }
          },
          cfia: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.cfia'),
            type: 'text',
            error: false,
            filters: {
              type: 'string'
              // minLength : 2,
              // maxLength : 15
            }
          },
          cif: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.cif'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              minLength: 2,
              maxLength: 15,
              required: true
            }
          },
          clientCode: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.client_code'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              minLength: 8,
              maxLength: 10,
              required: true
            }
          },
          email: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.email'),
            type: 'email',
            error: false,
            filters: {
              type: 'email',
              minLength: 7,
              maxLength: 100,
              required: true
            }
          },
          employeesQuantity: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.employees_quantity'),
            type: 'number',
            error: false,
            filters: {
              type: 'number',
              required: true
            }
          },
          loungesQuantity: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.lounges_quantity'),
            type: 'number',
            error: false,
            filters: {
              type: 'number',
              required: true
            }
          },
          legalName: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.legal_name'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              minLength: 2,
              maxLength: 40,
              required: true
            }
          },
          address: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.address'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              required: false
            }
          },
          city: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.city'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              required: false
            }
          },
          province: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.province'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              required: false
            }
          },
          postal_code: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.postal_code'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              minLength: 7,
              maxLength: 8,
              required: false
            }
          },
          // dischargeDate : {
          // 	id        : _.uniqueId('field_'),
          // 	display   : true,
          // 	fakeValue : '',
          // 	value     : '',
          // 	name      : this.$t('private.clients.list.fields.discharge_date'),
          // 	error     : false,
          // 	active    : false,
          // 	filters   : {
          // 		type      : 'date',
          // 		required  : true
          // 	}
          // },
          // status : {
          // 	id        : _.uniqueId('field_'),
          // 	display   : true,
          // 	fakeValue : this.$t('private.clients.list.fields.status_options.active'),
          // 	value     : true,
          // 	name      : this.$t('private.clients.list.fields.status'),
          // 	error     : false,
          // 	active    : false,
          // 	options : [{
          // 		fakeValue : this.$t('private.clients.list.fields.status_options.active'),
          // 		value : true
          // 	},{
          // 		fakeValue : this.$t('private.clients.list.fields.status_options.inactive'),
          // 		value : false
          // 	}],
          // 	filters : {
          // 		type      : 'boolean',
          // 		required  : true
          // 	}
          // },
          // recruitingLR : {
          // 	id        : _.uniqueId('field_'),
          // 	display   : true,
          // 	fakeValue : '',
          // 	value     : '',
          // 	name      : this.$t('private.clients.list.fields.recruiting_lr'),
          // 	error     : false,
          // 	active    : false,
          // 	options : [{
          // 		fakeValue : this.$t('private.clients.list.fields.recruiting_lr_options.yes'),
          // 		value : true
          // 	},{
          // 		fakeValue : this.$t('private.clients.list.fields.recruiting_lr_options.no'),
          // 		value : false
          // 	}],
          // 	filters : {
          // 		type      : 'boolean',
          // 		required  : true
          // 	}
          // },
          mktNews: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.clients.list.fields.mkt_news'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.clients.list.fields.mkt_news_options.yes'),
              value: true
            }, {
              fakeValue: this.$t('private.clients.list.fields.mkt_news_options.no'),
              value: false
            }],
            filters: {
              type: 'boolean',
              required: true
            }
          },
          emailInvoices: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.clients.list.fields.email_invoices'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.clients.list.fields.email_invoices_options.yes'),
              value: true
            }, {
              fakeValue: this.$t('private.clients.list.fields.email_invoices_options.no'),
              value: false
            }],
            filters: {
              type: 'boolean',
              required: true
            }
          }
          // conditions : {
          // 	id        : _.uniqueId('field_'),
          // 	display   : true,
          // 	name      : this.$t('private.clients.list.fields.conditions'),
          // 	error     : false,
          // 	value     : {
          // 		imageConditions : false
          // 	},
          // 	options   : {
          // 		imageConditions : {
          // 			name : this.$t('private.clients.list.fields.conditions_options.image_conditions')
          // 		}
          // 	},
          // 	filters   : {
          // 		type : 'manyOptions',
          // 		enum : ['imageConditions']
          // 	}
          // }
        },
        active: false
      },
      displayCreateClient: false,
      formUpdate: {
        fields: {
          id: {
            value: '',
            filters: {
              type: 'string',
              required: true
            }
          },
          seller: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.clients.list.fields.seller'),
            error: false,
            active: false,
            options: [],
            filters: {
              type: 'string',
              required: true
            }
          },
          cfia: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.cfia'),
            type: 'text',
            error: false,
            filters: {
              type: 'string'
              // minLength : 2,
              // maxLength : 15
            }
          },
          cif: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.cif'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              minLength: 2,
              maxLength: 15,
              required: true
            }
          },
          clientCode: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.client_code'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              minLength: 8,
              maxLength: 10,
              required: true
            }
          },
          email: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.email'),
            type: 'email',
            error: false,
            filters: {
              type: 'email'
              // minLength : 7,
              // maxLength : 100,
              // required  : true
            }
          },
          employeesQuantity: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.employees_quantity'),
            type: 'number',
            error: false,
            filters: {
              type: 'number'
              // required  : true
            }
          },
          loungesQuantity: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.lounges_quantity'),
            type: 'number',
            error: false,
            filters: {
              type: 'number'
              // required  : true
            }
          },
          legalName: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.legal_name'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              minLength: 2,
              maxLength: 40,
              required: true
            }
          },
          phone: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.phone'),
            type: 'text',
            error: false,
            filters: {
              type: 'string'
              // minLength : 2,
              // maxLength : 40
            }
          },
          cellphone: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.cellphone'),
            type: 'text',
            error: false,
            filters: {
              type: 'string'
              // minLength : 2,
              // maxLength : 40
            }
          },
          address: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.address'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              required: false
            }
          },
          city: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.city'),
            type: 'text',
            error: false,
            filters: {
              type: 'string'
              // minLength : 2,
              // maxLength : 15
            }
          },
          province: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.province'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              required: false
            }
          },
          postal_code: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.postal_code'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              minLength: 7,
              maxLength: 8,
              required: false
            }
          },
          web: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.web'),
            type: 'text',
            error: false,
            filters: {
              type: 'string'
              // minLength : 2,
              // maxLength : 40
            }
          },
          ownerName: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.owner_name'),
            type: 'text',
            error: false,
            filters: {
              type: 'string'
              // minLength : 2,
              // maxLength : 40
            }
          },
          headquarters: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.headquarters'),
            type: 'text',
            error: false,
            filters: {
              type: 'string'
              // minLength : 2,
              // maxLength : 40
            }
          },
          onlineShop: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.clients.list.fields.online_shop'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.clients.list.fields.online_shop_options.yes'),
              value: true
            }, {
              fakeValue: this.$t('private.clients.list.fields.online_shop_options.no'),
              value: false
            }],
            filters: {
              type: 'boolean',
              required: true
            }
          },
          resaleShop: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.clients.list.fields.resale_shop'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.clients.list.fields.resale_shop_options.yes'),
              value: true
            }, {
              fakeValue: this.$t('private.clients.list.fields.resale_shop_options.no'),
              value: false
            }],
            filters: {
              type: 'boolean',
              required: true
            }
          },
          dischargeDate: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.clients.list.fields.discharge_date'),
            error: false,
            active: false,
            filters: {
              type: 'date',
              required: true
            }
          },
          status: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.clients.list.fields.status'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.clients.list.fields.status_options.active'),
              value: true
            }, {
              fakeValue: this.$t('private.clients.list.fields.status_options.inactive'),
              value: false
            }],
            filters: {
              type: 'boolean',
              required: true
            }
          },
          recruitingLR: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.clients.list.fields.recruiting_lr'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.clients.list.fields.recruiting_lr_options.yes'),
              value: true
            }, {
              fakeValue: this.$t('private.clients.list.fields.recruiting_lr_options.no'),
              value: false
            }],
            filters: {
              type: 'boolean'
              // required  : true
            }
          },
          mktNews: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.clients.list.fields.mkt_news'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.clients.list.fields.mkt_news_options.yes'),
              value: true
            }, {
              fakeValue: this.$t('private.clients.list.fields.mkt_news_options.no'),
              value: false
            }],
            filters: {
              type: 'boolean',
              required: true
            }
          },
          emailInvoices: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.clients.list.fields.email_invoices'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.clients.list.fields.email_invoices_options.yes'),
              value: true
            }, {
              fakeValue: this.$t('private.clients.list.fields.email_invoices_options.no'),
              value: false
            }],
            filters: {
              type: 'boolean',
              required: true
            }
          },
          haveSalon: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.clients.list.fields.have_salon'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.clients.list.fields.have_salon_options.yes'),
              value: true
            }, {
              fakeValue: this.$t('private.clients.list.fields.have_salon_options.no'),
              value: false
            }],
            filters: {
              type: 'boolean',
              required: true
            }
          },
          nioxinPastQuantity: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.nioxin_past_quantity'),
            type: 'number',
            error: false,
            filters: {
              type: 'number'
            }
          },
          sebastianPastQuantity: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.sebastian_past_quantity'),
            type: 'number',
            error: false,
            filters: {
              type: 'number'
            }
          },
          spPastQuantity: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.sp_past_quantity'),
            type: 'number',
            error: false,
            filters: {
              type: 'number'
            }
          },
          systemECPastQuantity: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.system_ec_past_quantity'),
            type: 'number',
            error: false,
            filters: {
              type: 'number'
            }
          },
          wellaPastQuantity: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.wella_past_quantity'),
            type: 'number',
            error: false,
            filters: {
              type: 'number'
            }
          },
          wellaRealPastQuantity: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.wella_real_past_quantity'),
            type: 'number',
            error: false,
            filters: {
              type: 'number'
            }
          },
          totalContractedPastQuantity: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.total_contracted_past_quantity'),
            type: 'number',
            error: false,
            filters: {
              type: 'number'
            }
          },
          conditions: {
            id: _.uniqueId('field_'),
            display: true,
            name: this.$t('private.clients.list.fields.conditions'),
            error: false,
            value: {
              imageConditions: false
            },
            options: {
              imageConditions: {
                name: this.$t('private.clients.list.fields.conditions_options.image_conditions')
              }
            },
            filters: {
              type: 'manyOptions',
              enum: ['imageConditions']
            }
          }
        },
        active: false
      },
      displayUpdateClient: false,
      getSellersActive: false,
      displaySeeAssociatedAccounts: false,
      associatedAccountsWindow: {
        display: false,
        client: {},
        associatedAccounts: [],
        menuOptions: [
          {
            iconClass: 'fa fa-trash',
            name: this.$t('private.clients.list.associated_accounts_modal.menu_more_options.delete_association'),
            action: 'deleteAssociation'
          }
        ]
      },
      importClientsWindow: {
        display: false,
        validateCSVFileActive: false,
        importClientsActive: false,
        clientsToCreate: [],
        clientsToUpdate: [],
        clientsWithErrors: [],
        fields: {
          separator: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.semicolon'),
            value: ';',
            name: this.$t('private.clients.list.import_clients_modal.fields.separator'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.coma'),
              value: ','
            }, {
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.semicolon'),
              value: ';'
            }, {
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.pipe'),
              value: '|'
            }],
            filters: {
              type: 'string',
              enum: [',', ';', '|'],
              required: true
            },
            style: {
              marginTop: '40px'
            }
          },
          csv: {
            id: _.uniqueId('field_'),
            display: true,
            value: {},
            name: this.$t('private.clients.list.import_clients_modal.fields.csv'),
            csv: true,
            readAsText: true,
            fileReady: false,
            error: false,
            active: false,
            filters: {
              type: 'file',
              maxSize: 3.5,
              formatsAllowed: ['vnd.ms-excel', 'csv'],
              required: true
            }
          }
        },
        selectedClientsToUpdate: [],
        allChecksUpdate: [],
        activateAllCheckboxUpdate: {
          id: _.uniqueId('field_'),
          display: true,
          error: false,
          value: {
            active: false
          },
          options: {
            active: {}
          },
          filters: {
            type: 'manyOptions'
          }
        },
        selectedClientsToCreate: [],
        allChecksCreate: [],
        activateAllCheckboxCreate: {
          id: _.uniqueId('field_'),
          display: true,
          error: false,
          value: {
            active: false
          },
          options: {
            active: {}
          },
          filters: {
            type: 'manyOptions'
          }
        }
      },
      migrateClientsWindow: {
        display: false,
        migrateCSVFileActive: false,
        clientsToCreated: [],
        clientsWithErrors: [],
        fields: {
          separator: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.semicolon'),
            value: ';',
            name: this.$t('private.clients.list.import_clients_modal.fields.separator'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.coma'),
              value: ','
            }, {
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.semicolon'),
              value: ';'
            }, {
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.pipe'),
              value: '|'
            }],
            filters: {
              type: 'string',
              enum: [',', ';', '|'],
              required: true
            },
            style: {
              marginTop: '40px'
            }
          },
          csv: {
            id: _.uniqueId('field_'),
            display: true,
            value: {},
            name: this.$t('private.clients.list.import_clients_modal.fields.csv'),
            csv: true,
            readAsText: true,
            fileReady: false,
            error: false,
            active: false,
            filters: {
              type: 'file',
              maxSize: 10,
              formatsAllowed: ['vnd.ms-excel', 'csv'],
              required: true
            }
          }
        }
      },
      migrateAssociatedAccountsWindow: {
        display: false,
        migrateCSVFileActive: false,
        associateccountCreated: [],
        associateccountWithErrors: [],
        fields: {
          separator: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.semicolon'),
            value: ';',
            name: this.$t('private.clients.list.import_clients_modal.fields.separator'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.coma'),
              value: ','
            }, {
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.semicolon'),
              value: ';'
            }, {
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.pipe'),
              value: '|'
            }],
            filters: {
              type: 'string',
              enum: [',', ';', '|'],
              required: true
            },
            style: {
              marginTop: '40px'
            }
          },
          csv: {
            id: _.uniqueId('field_'),
            display: true,
            value: {},
            name: this.$t('private.clients.list.import_clients_modal.fields.csv'),
            csv: true,
            readAsText: true,
            fileReady: false,
            error: false,
            active: false,
            filters: {
              type: 'file',
              maxSize: 10,
              formatsAllowed: ['vnd.ms-excel', 'csv'],
              required: true
            }
          }
        }
      },
      exportClientsActive: false,
      getSearchSellers: false,
      displayFoo: false
    }
  },
  methods: {
    filterSubmit: _.debounce(function () {
      let vm = this

      vm.getClients()
    }, 1000),
    rowClicked (element, value) {
      element.rowSelected = value

      this.displayFoo ? this.displayFoo = false : this.displayFoo = true
    },
    getClients () {
      let vm = this

      vm.clients = []
      vm.getClientsActive = true

      let dataToSend =
        '/?cif=' + vm.filters.cif.value +
        '&clientCode=' + vm.filters.clientCode.value +
        // '&email='      + vm.filters.email.value       +
        '&legalName=' + vm.filters.legalName.value +
        '&ascending=' + vm.filters.ascending.value +
        '&descending=' + vm.filters.descending.value +
        '&limit=' + (vm.filters.limit.value + 1) +
        '&skip=' + vm.filters.skip.value

      api
        .clients
        .getClients(dataToSend)
        .then((response) => {
          vm.getClientsActive = false

          if (response.status != 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (!response.data.success) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          vm.clients = response.data.clients

          if (vm.clients.length > 0 && !vm.haveData) {
            vm.haveData = true
          }

          if (vm.clients.length > vm.filters.limit.value) {
            vm.nextPage = true

            vm.clients.pop()
          } else {
            vm.nextPage = false
          }
        })
    },
    goToBackPage () {
      let vm = this

      if (vm.filters.skip.value != 0) {
        vm.filters.skip.value = vm.filters.skip.value - vm.filters.limit.value

        vm.getClients()
      }
    },
    goToNextPage () {
      let vm = this

      if (vm.nextPage) {
        vm.filters.skip.value = vm.filters.skip.value + vm.filters.limit.value

        vm.getClients()
      }
    },
    optionSelected (data) {
      let vm = this

      if (data.action == 'associateAccount') {
        vm.formAssociateAccount.fields.id.value = data.element.id
        vm.formAssociateAccount.fields.client.value = ''
        vm.formAssociateAccount.fields.legalName.value = ''
        vm.formAssociateAccount.fields.cif.value = ''
        vm.formAssociateAccount.fields.email.value = ''

        vm.searchClientsForAssociated('')

        vm.displayAssociateAccount = true
      } else if (data.action == 'seeAssociatedAccounts') {
        if (data.element.associatedAccounts.length == 0) {
          let message = {
            message: [vm.$t('private.clients.list.not_have_associated_accounts')],
            type: 'error'
          }

          vm.$root.$emit('showMessage', message)

          return
        }

        vm.associatedAccountsWindow.display = true
        vm.associatedAccountsWindow.client = data.element
        vm.associatedAccountsWindow.associatedAccounts = data.element.associatedAccounts
      } else if (data.action == 'deleteAssociation') {
        vm.deleteAssociationAccount(data.element)
      } else if (data.action == 'edit') {
        vm.formUpdate.fields.id.value = data.element.id
        vm.formUpdate.fields.seller.fakeValue = data.element.seller ? data.element.seller.fullname + ' ( ' + data.element.seller.username + ' )' : ''
        vm.formUpdate.fields.seller.value = data.element.seller ? data.element.seller.objectId : ''
        vm.formUpdate.fields.cfia.value = data.element.cfia ? data.element.cfia : ''
        vm.formUpdate.fields.cif.value = data.element.cif ? data.element.cif : ''
        vm.formUpdate.fields.address.value = data.element.address ? data.element.address : ''
        vm.formUpdate.fields.city.value = data.element.town ? data.element.town : ''
        vm.formUpdate.fields.province.value = data.element.province ? data.element.province : ''
        vm.formUpdate.fields.postal_code.value = data.element.zipcode ? data.element.zipcode : ''
        vm.formUpdate.fields.clientCode.value = data.element.clientCode ? data.element.clientCode : ''
        vm.formUpdate.fields.email.value = data.element.email ? data.element.email : ''
        vm.formUpdate.fields.employeesQuantity.value = data.element.employeesQuantity ? data.element.employeesQuantity : 0
        vm.formUpdate.fields.loungesQuantity.value = data.element.loungesQuantity ? data.element.loungesQuantity : 0
        vm.formUpdate.fields.legalName.value = data.element.legalName ? data.element.legalName : ''
        vm.formUpdate.fields.phone.value = data.element.phone ? data.element.phone : ''
        vm.formUpdate.fields.cellphone.value = data.element.cellphone ? data.element.cellphone : ''
        vm.formUpdate.fields.web.value = data.element.web ? data.element.web : ''
        vm.formUpdate.fields.ownerName.value = data.element.ownerName ? data.element.ownerName : ''
        vm.formUpdate.fields.headquarters.value = data.element.headquarters ? data.element.headquarters : ''
        vm.formUpdate.fields.onlineShop.fakeValue = data.element.onlineShop ? vm.$t('private.clients.list.fields.online_shop_options.yes') : vm.$t('private.clients.list.fields.online_shop_options.no')
        vm.formUpdate.fields.onlineShop.value = !!data.element.onlineShop
        vm.formUpdate.fields.resaleShop.fakeValue = data.element.resaleShop ? vm.$t('private.clients.list.fields.resale_shop_options.yes') : vm.$t('private.clients.list.fields.resale_shop_options.no')
        vm.formUpdate.fields.resaleShop.value = !!data.element.resaleShop
        vm.formUpdate.fields.haveSalon.fakeValue = data.element.haveSalon ? vm.$t('private.clients.list.fields.have_salon_options.yes') : vm.$t('private.clients.list.fields.have_salon_options.no')
        vm.formUpdate.fields.haveSalon.value = !!data.element.haveSalon
        vm.formUpdate.fields.nioxinPastQuantity.value = data.element.nioxinPastQuantity ? data.element.nioxinPastQuantity : 0
        vm.formUpdate.fields.sebastianPastQuantity.value = data.element.sebastianPastQuantity ? data.element.sebastianPastQuantity : 0
        vm.formUpdate.fields.spPastQuantity.value = data.element.spPastQuantity ? data.element.spPastQuantity : 0
        vm.formUpdate.fields.systemECPastQuantity.value = data.element.systemECPastQuantity ? data.element.systemECPastQuantity : 0
        vm.formUpdate.fields.wellaPastQuantity.value = data.element.wellaPastQuantity ? data.element.wellaPastQuantity : 0
        vm.formUpdate.fields.wellaRealPastQuantity.value = data.element.wellaRealPastQuantity ? data.element.wellaRealPastQuantity : 0
        vm.formUpdate.fields.totalContractedPastQuantity.value = data.element.totalContractedPastQuantity ? data.element.totalContractedPastQuantity : 0
        vm.formUpdate.fields.dischargeDate.fakeValue = data.element.dischargeDate ? moment(data.element.dischargeDate.iso).format('DD-MM-YYYY') : ''
        vm.formUpdate.fields.dischargeDate.value = data.element.dischargeDate ? data.element.dischargeDate.iso : ''
        vm.formUpdate.fields.status.fakeValue = data.element.status ? vm.$t('private.clients.list.fields.status_options.active') : vm.$t('private.clients.list.fields.status_options.inactive')
        vm.formUpdate.fields.status.value = !!data.element.status
        vm.formUpdate.fields.recruitingLR.fakeValue = data.element.recruitingLR ? vm.$t('private.clients.list.fields.recruiting_lr_options.yes') : vm.$t('private.clients.list.fields.recruiting_lr_options.no')
        vm.formUpdate.fields.recruitingLR.value = !!data.element.recruitingLR
        vm.formUpdate.fields.mktNews.fakeValue = data.element.mktNews ? vm.$t('private.clients.list.fields.mkt_news_options.yes') : vm.$t('private.clients.list.fields.mkt_news_options.no')
        vm.formUpdate.fields.mktNews.value = !!data.element.mktNews
        vm.formUpdate.fields.emailInvoices.fakeValue = data.element.emailInvoices ? vm.$t('private.clients.list.fields.email_invoices_options.yes') : vm.$t('private.clients.list.fields.email_invoices_options.no')
        vm.formUpdate.fields.emailInvoices.value = !!data.element.emailInvoices
        vm.formUpdate.fields.conditions.value.imageConditions = !!data.element.imageConditions

        vm.displayUpdateClient = true
      } else if (data.action == 'delete') {
        vm.deleteClient(data.element)
      }
    },
    searchClientsForAssociated (data) {
      let vm = this

      vm.getSearchClientsForAssociated = true

      let dataToSend = '?clientCode=' + data

      api
        .clients
        .getClients(dataToSend)
        .then((response) => {
          vm.getSearchClientsForAssociated = false

          if (response.status != 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (!response.data.success) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          let clients = response.data.clients

          clients = _.map(clients, (client) => {
            return {
              fakeValue: client.legalName + ' (' + client.clientCode + ')',
              value: client
            }
          })

          vm.formAssociateAccount.fields.client.options = clients
        })
    },
    clientForAssociatedSelected (data) {
      let vm = this

      vm.formAssociateAccount.fields.client.value = data.id
      vm.formAssociateAccount.fields.legalName.value = data.legalName
      vm.formAssociateAccount.fields.cif.value = data.cif
      vm.formAssociateAccount.fields.email.value = data.email
    },
    formAssociateAccountSubmit () {
      let vm = this

      if (vm.formAssociateAccount.active) {
        return
      }

      vm.formAssociateAccount.active = true

      vm.$root.$emit('validate', [vm.formAssociateAccount.fields, (response) => {
        if (!response.success) {
          vm.formAssociateAccount.active = false

          response.type = 'error'

          response.field.error = true

          let dataToScroll = {
            selector: '#' + response.field.id,
            target: 'html, body'
          }

          ScrollTo.submit(dataToScroll)

          vm.$root.$emit('showMessage', response)

          return
        }

        let dataToSend = {
          id: vm.formAssociateAccount.fields.id.value,
          accountToAssociate: vm.formAssociateAccount.fields.client.value
        }

        api
          .clients
          .associateAccount(dataToSend)
          .then((response) => {
            vm.formAssociateAccount.active = false

            if (response.status != 200) {
              let message = {
                message: [vm.$t('errors.custom.001')],
                type: 'error'
              }

              vm.$root.$emit('showMessage', message)

              return
            }

            if (!response.data.success) {
              if (response.data.error.code == 101) {
                let message = {
                  message: [vm.$t('errors.parse.101')],
                  type: 'error'
                }

                vm.$root.$emit('showMessage', message)
              }

              return
            }

            let message = {
              message: [vm.$t('private.clients.list.associate_account_modal.success')],
              type: 'success'
            }

            vm.$root.$emit('showMessage', message)

            vm.getClients()

            vm.displayAssociateAccount = false

            vm.formAssociateAccount.fields.client.value = ''
            vm.formAssociateAccount.fields.legalName.value = ''
            vm.formAssociateAccount.fields.cif.value = ''
            vm.formAssociateAccount.fields.email.value = ''
          })
      }])
    },
    deleteAssociationAccount (element) {
      let vm = this

      let questionModal = {
        title: this.$t('private.clients.list.associated_accounts_modal.question_modal.title'),
        question: this.$t('private.clients.list.associated_accounts_modal.question_modal.question')
      }

      vm.$root.$emit('question-modal', [questionModal, (response) => {
        if (response) {
          let dataToSend =
            '?clientId=' + vm.associatedAccountsWindow.client.id +
            '&associatedAccountId=' + element.objectId

          api
            .clients
            .deleteAssociationAccount(dataToSend)
            .then((response) => {
              vm.formUpdate.active = false

              if (response.status != 200) {
                let message = {
                  message: [vm.$t('errors.custom.001')],
                  type: 'error'
                }

                vm.$root.$emit('showMessage', message)

                return
              }

              if (!response.data.success) {
                if (response.data.error.code == 101) {
                  let message = {
                    message: [vm.$t('errors.parse.101')],
                    type: 'error'
                  }

                  vm.$root.$emit('showMessage', message)
                }

                return
              }

              let message = {
                message: [vm.$t('private.clients.list.associated_accounts_modal.delete_success')],
                type: 'success'
              }

              vm.$root.$emit('showMessage', message)

              vm.associatedAccountsWindow.display = false

              vm.getClients()
            })
        }
      }])
    },
    formCreateSubmit () {
      let vm = this

      if (vm.formCreate.active) {
        return
      }

      vm.formCreate.active = true

      vm.$root.$emit('validate', [vm.formCreate.fields, (response) => {
        if (!response.success) {
          vm.formCreate.active = false

          response.type = 'error'

          response.field.error = true

          let dataToScroll = {
            selector: '#' + response.field.id,
            target: 'html, body'
          }

          ScrollTo.submit(dataToScroll)

          vm.$root.$emit('showMessage', response)

          return
        }

        let dataToSend = {
          seller: vm.formCreate.fields.seller.value,
          cfia: vm.formCreate.fields.cfia.value,
          cif: vm.formCreate.fields.cif.value,
          clientCode: vm.formCreate.fields.clientCode.value,
          legalName: vm.formCreate.fields.legalName.value,
          dischargeDate: moment().toDate(),
          email: vm.formCreate.fields.email.value,
          employeesQuantity: vm.formCreate.fields.employeesQuantity.value,
          loungesQuantity: vm.formCreate.fields.loungesQuantity.value,
          // dischargeDate     : moment(vm.formCreate.fields.dischargeDate.value).endOf('').toDate(),
          // status            : vm.formCreate.fields.status.value,
          // recruitingLR      : vm.formCreate.fields.recruitingLR.value,
          address: vm.formCreate.fields.address.value,
          town: vm.formCreate.fields.city.value,
          province: vm.formCreate.fields.province.value,
          zipcode: vm.formCreate.fields.postal_code.value,
          mktNews: vm.formCreate.fields.mktNews.value,
          emailInvoices: vm.formCreate.fields.emailInvoices.value
          // imageConditions   : vm.formCreate.fields.conditions.value.imageConditions
        }

        api
          .clients
          .createClient(dataToSend)
          .then((response) => {
            vm.formCreate.active = false

            if (response.status != 200) {
              let message = {
                message: [vm.$t('errors.custom.001')],
                type: 'error'
              }

              vm.$root.$emit('showMessage', message)

              return
            }

            if (!response.data.success) {
              if (response.data.error.code == '002') {
                vm.formCreate.fields.clientCode.error = true

                let message = {
                  message: [vm.$t('errors.custom.002')],
                  type: 'error'
                }

                vm.$root.$emit('showMessage', message)
              }

              if (response.data.error.code == '007') {
                vm.formCreate.fields.cif.error = true

                let message = {
                  message: [vm.$t('errors.custom.007')],
                  type: 'error'
                }

                vm.$root.$emit('showMessage', message)
              }

              return
            }

            let message = {
              message: [vm.$t('private.clients.list.create_success')],
              type: 'success'
            }

            vm.$root.$emit('showMessage', message)

            vm.getClients()

            vm.displayCreateClient = false

            vm.formCreate.fields.seller.value = ''
            vm.formCreate.fields.cif.value = ''
            vm.formCreate.fields.clientCode.value = ''
            vm.formCreate.fields.legalName.value = ''
            vm.formCreate.fields.address.value = ''
            vm.formCreate.fields.city.value = ''
            vm.formCreate.fields.province.value = ''
            vm.formCreate.fields.postal_code.value = ''
            // vm.formCreate.fields.dischargeDate.value              = ''
            // vm.formCreate.fields.email.value                      = ''
            // vm.formCreate.fields.employeesQuantity.value          = ''
            // vm.formCreate.fields.loungesQuantity.value            = ''
            // vm.formCreate.fields.dischargeDate.value              = ''
            // vm.formCreate.fields.status.value                     = ''
            // vm.formCreate.fields.recruitingLR.value               = ''
            vm.formCreate.fields.mktNews.value = ''
            vm.formCreate.fields.emailInvoices.value = ''
            // vm.formCreate.fields.conditions.value.imageConditions = false
          })
      }])
    },
    formUpdateSubmit () {
      let vm = this

      if (vm.formUpdate.active) {
        return
      }

      vm.formUpdate.active = true

      vm.$root.$emit('validate', [vm.formUpdate.fields, (response) => {
        if (!response.success) {
          vm.formUpdate.active = false

          response.type = 'error'

          response.field.error = true

          let dataToScroll = {
            selector: '#' + response.field.id,
            target: 'html, body'
          }

          ScrollTo.submit(dataToScroll)

          vm.$root.$emit('showMessage', response)

          return
        }

        let dataToSend = {
          id: vm.formUpdate.fields.id.value,
          seller: vm.formUpdate.fields.seller.value,
          cfia: vm.formUpdate.fields.cfia.value,
          cif: vm.formUpdate.fields.cif.value,
          clientCode: vm.formUpdate.fields.clientCode.value,
          email: vm.formUpdate.fields.email.value,
          employeesQuantity: vm.formUpdate.fields.employeesQuantity.value,
          loungesQuantity: vm.formUpdate.fields.loungesQuantity.value,
          legalName: vm.formUpdate.fields.legalName.value,
          phone: vm.formUpdate.fields.phone.value,
          cellphone: vm.formUpdate.fields.cellphone.value,
          web: vm.formUpdate.fields.web.value,
          address: vm.formUpdate.fields.address.value,
          town: vm.formUpdate.fields.city.value,
          province: vm.formUpdate.fields.province.value,
          zipcode: vm.formUpdate.fields.postal_code.value,
          ownerName: vm.formUpdate.fields.ownerName.value,
          headquarters: vm.formUpdate.fields.headquarters.value,
          onlineShop: vm.formUpdate.fields.onlineShop.value,
          resaleShop: vm.formUpdate.fields.resaleShop.value,
          haveSalon: vm.formUpdate.fields.haveSalon.value,
          nioxinPastQuantity: vm.formUpdate.fields.nioxinPastQuantity.value,
          sebastianPastQuantity: vm.formUpdate.fields.sebastianPastQuantity.value,
          spPastQuantity: vm.formUpdate.fields.spPastQuantity.value,
          systemECPastQuantity: vm.formUpdate.fields.systemECPastQuantity.value,
          wellaPastQuantity: vm.formUpdate.fields.wellaPastQuantity.value,
          wellaRealPastQuantity: vm.formUpdate.fields.wellaRealPastQuantity.value,
          totalContractedPastQuantity: vm.formUpdate.fields.totalContractedPastQuantity.value,
          dischargeDate: moment(vm.formUpdate.fields.dischargeDate.value).endOf('day').toDate(),
          status: vm.formUpdate.fields.status.value,
          // recruitingLR                : vm.formUpdate.fields.recruitingLR.value,
          mktNews: vm.formUpdate.fields.mktNews.value,
          emailInvoices: vm.formUpdate.fields.emailInvoices.value,
          imageConditions: vm.formUpdate.fields.conditions.value.imageConditions
        }

        api
          .clients
          .updateClient(dataToSend)
          .then((response) => {
            vm.formUpdate.active = false

            if (response.status != 200) {
              let message = {
                message: [vm.$t('errors.custom.001')],
                type: 'error'
              }

              vm.$root.$emit('showMessage', message)

              return
            }

            if (!response.data.success) {
              if (response.data.error.code == '002') {
                vm.formUpdate.fields.clientCode.error = true

                let message = {
                  message: [vm.$t('errors.custom.002')],
                  type: 'error'
                }

                vm.$root.$emit('showMessage', message)
              }

              if (response.data.error.code == '007') {
                vm.formCreate.fields.cif.error = true

                let message = {
                  message: [vm.$t('errors.custom.007')],
                  type: 'error'
                }

                vm.$root.$emit('showMessage', message)
              }

              return
            }

            let message = {
              message: [vm.$t('private.clients.list.update_success')],
              type: 'success'
            }

            vm.$root.$emit('showMessage', message)

            vm.getClients()

            vm.displayUpdateClient = false

            vm.formUpdate.fields.id.value = ''
            vm.formUpdate.fields.seller.value = ''
            vm.formUpdate.fields.cfia.value = ''
            vm.formUpdate.fields.cif.value = ''
            vm.formUpdate.fields.address.value = ''
            vm.formUpdate.fields.city.value = ''
            vm.formUpdate.fields.province.value = ''
            vm.formUpdate.fields.postal_code.value = ''
            vm.formUpdate.fields.clientCode.value = ''
            vm.formUpdate.fields.email.value = ''
            vm.formUpdate.fields.employeesQuantity.value = ''
            vm.formUpdate.fields.loungesQuantity.value = ''
            vm.formUpdate.fields.legalName.value = ''
            vm.formUpdate.fields.dischargeDate.value = ''
            vm.formUpdate.fields.status.value = ''
            vm.formUpdate.fields.recruitingLR.value = ''
            vm.formUpdate.fields.mktNews.value = ''
            vm.formUpdate.fields.emailInvoices.value = ''
            vm.formUpdate.fields.conditions.value.imageConditions = false
          })
      }])
    },
    deleteClient (element) {
      let vm = this

      let questionModal = {
        title: this.$t('private.clients.list.question_modal.title'),
        question: this.$t('private.clients.list.question_modal.question')
      }

      vm.$root.$emit('question-modal', [questionModal, (response) => {
        if (response) {
          let dataToSend = '/?id=' + element.id

          api
            .clients
            .deleteClient(dataToSend)
            .then((response) => {
              vm.formUpdate.active = false

              if (response.status != 200) {
                let message = {
                  message: [vm.$t('errors.custom.001')],
                  type: 'error'
                }

                vm.$root.$emit('showMessage', message)

                return
              }

              if (!response.data.success) {
                if (response.data.error.code == 101) {
                  let message = {
                    message: [vm.$t('errors.parse.101')],
                    type: 'error'
                  }

                  vm.$root.$emit('showMessage', message)
                }

                return
              }

              let message = {
                message: [vm.$t('private.clients.list.delete_success')],
                type: 'success'
              }

              vm.$root.$emit('showMessage', message)

              vm.getClients()
            })
        }
      }])
    },
    searchSellers (data) {
      let vm = this

      vm.getSellersActive = true

      let dataToSend = '?descending=createdAt&fullname=' + data

      api
        .sellers
        .getSellers(dataToSend)
        .then((response) => {
          vm.getSellersActive = false

          if (response.status != 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (!response.data.success) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          let sellers = _.sortBy(response.data.sellers, 'username')

          sellers = _.map(sellers, (seller) => {
            return {
              fakeValue: seller.fullname + ' ( ' + seller.username + ' )',
              value: seller.id
            }
          })

          vm.formCreate.fields.seller.options = sellers
          vm.formUpdate.fields.seller.options = sellers
        })
    },
    sellerSelected (data) {
      let vm = this

      vm.formCreate.fields.seller.value = data
      vm.formUpdate.fields.seller.value = data
    },
    displayDataToTooltip (client) {
      let clientsRows = ''

      for (var i = 0; i < client.associatedAccounts.length; i++) {
        clientsRows = clientsRows +
          '<div>' + client.associatedAccounts[i].legalName + ' (' + client.associatedAccounts[i].clientCode + ')</div>'
      }

      return clientsRows
    },
    validateCSVFile () {
      let vm = this

      vm.$root.$emit('validate', [vm.importClientsWindow.fields, (response) => {
        console.log(vm.importClientsWindow.fields)

        if (!response.success) {
          vm.formCreate.active = false

          response.type = 'error'

          response.field.error = true

          let dataToScroll = {
            selector: '#' + response.field.id,
            target: 'html, body'
          }

          ScrollTo.submit(dataToScroll)

          vm.$root.$emit('showMessage', response)

          return
        }

        let dataToSend = {
          separator: vm.importClientsWindow.fields.separator.value,
          csv: vm.importClientsWindow.fields.csv.value.data
        }

        vm.importClientsWindow.validateCSVFileActive = true

        api
          .clients
          .validateCSVFile(dataToSend)
          .then((response) => {
            vm.importClientsWindow.validateCSVFileActive = false

            if (response.status != 200) {
              let message = {
                message: [vm.$t('errors.custom.001')],
                type: 'error'
              }

              vm.$root.$emit('showMessage', message)

              return
            }

            if (!response.data.success) {
              let message = {
                message: [vm.$t('errors.custom.001')],
                type: 'error'
              }

              vm.$root.$emit('showMessage', message)

              return
            }

            vm.importClientsWindow.clientsToCreate = response.data.clientsToCreate
            vm.importClientsWindow.clientsToUpdate = response.data.clientsToUpdate
            vm.importClientsWindow.clientsWithErrors = response.data.clientsWithErrors

            vm.importClientsWindow.allChecksUpdate = _.map(vm.importClientsWindow.clientsToUpdate, (client) => {
              let field = {
                id: _.uniqueId('field_'),
                display: true,
                error: false,
                value: {},
                options: {},
                filters: {
                  type: 'manyOptions'
                }
              }

              field.value[client.clientCode] = false

              field.options[client.clientCode] = {}

              return field
            })

            vm.importClientsWindow.allChecksCreate = _.map(vm.importClientsWindow.clientsToCreate, (client) => {
              let field = {
                id: _.uniqueId('field_'),
                display: true,
                error: false,
                value: {},
                options: {},
                filters: {
                  type: 'manyOptions'
                }
              }

              field.value[client.clientCode] = false

              field.options[client.clientCode] = {}

              return field
            })
          })
      }])
    },
    importClientsSelected () {
      let vm = this

      let clientsToUpdate = _.filter(vm.importClientsWindow.selectedClientsToUpdate, (element) => {
        if (!element) {
          return false
        }

        let key = ''

        for (let i in element) {
          key = i
        }

        return element[key]
      })

      clientsToUpdate = _.map(clientsToUpdate, (element) => {
        let key = ''

        for (let i in element) {
          key = i
        }

        return key
      })

      clientsToUpdate = _.map(clientsToUpdate, (clientCode) => {
        return _.find(vm.importClientsWindow.clientsToUpdate, {clientCode: clientCode})
      })

      let clientsToCreate = _.filter(vm.importClientsWindow.selectedClientsToCreate, (element) => {
        if (!element) {
          return false
        }

        let key = ''

        for (let i in element) {
          key = i
        }

        return element[key]
      })

      clientsToCreate = _.map(clientsToCreate, (element) => {
        let key = ''

        for (let i in element) {
          key = i
        }

        return key
      })

      clientsToCreate = _.map(clientsToCreate, (clientCode) => {
        return _.find(vm.importClientsWindow.clientsToCreate, {clientCode: clientCode})
      })

      if (clientsToUpdate.length == 0 && clientsToCreate.length == 0) {
        let message = {
          message: [vm.$t('private.clients.list.import_clients_modal.no_data_to_import')],
          type: 'error'
        }

        vm.$root.$emit('showMessage', message)

        return
      }

      let dataToSend = {
        clientsToUpdate,
        clientsToCreate
      }

      vm.importClientsWindow.importClientsActive = true

      api
        .clients
        .importClients(dataToSend)
        .then((response) => {
          vm.importClientsWindow.importClientsActive = false

          if (response.status != 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (!response.data.success) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          vm.getClients()

          vm.importClientsWindow.display = false

          let message = {
            message: [vm.$t('private.clients.list.import_clients_modal.import_success')],
            type: 'success'
          }

          vm.$root.$emit('showMessage', message)

          vm.resetDataImportClientsWindow()
        })
    },
    activateAllCheckboxToggleUpdate () {
      let vm = this

      vm.importClientsWindow.selectedClientsToUpdate = []

      if (vm.importClientsWindow.activateAllCheckboxUpdate.value.active) {
        for (let i = 0; i < vm.importClientsWindow.allChecksUpdate.length; i++) {
          for (let j in vm.importClientsWindow.allChecksUpdate[i].value) {
            vm.importClientsWindow.allChecksUpdate[i].value[j] = true
          }
        }
      } else {
        for (let i = 0; i < vm.importClientsWindow.allChecksUpdate.length; i++) {
          for (let j in vm.importClientsWindow.allChecksUpdate[i].value) {
            vm.importClientsWindow.allChecksUpdate[i].value[j] = false
          }
        }
      }
    },
    activateAllCheckboxToggleCreate () {
      let vm = this

      vm.importClientsWindow.selectedClientsToCreate = []

      if (vm.importClientsWindow.activateAllCheckboxCreate.value.active) {
        for (let i = 0; i < vm.importClientsWindow.allChecksCreate.length; i++) {
          for (let j in vm.importClientsWindow.allChecksCreate[i].value) {
            vm.importClientsWindow.allChecksCreate[i].value[j] = true
          }
        }
      } else {
        for (let i = 0; i < vm.importClientsWindow.allChecksCreate.length; i++) {
          for (let j in vm.importClientsWindow.allChecksCreate[i].value) {
            vm.importClientsWindow.allChecksCreate[i].value[j] = false
          }
        }
      }
    },
    resetDataImportClientsWindow () {
      let vm = this

      vm.importClientsWindow.clientsToCreate = []
      vm.importClientsWindow.clientsToUpdate = []
      vm.importClientsWindow.clientsWithErrors = []
      vm.importClientsWindow.fields.csv.value = {}
      vm.importClientsWindow.fields.csv.fileReady = false
      vm.importClientsWindow.selectedClientsToUpdate = []
      vm.importClientsWindow.allChecksUpdate = []
      vm.importClientsWindow.activateAllCheckboxUpdate.value.active = false
      vm.importClientsWindow.selectedClientsToCreate = []
      vm.importClientsWindow.allChecksCreate = []
      vm.importClientsWindow.activateAllCheckboxCreate.value.active = false
    },
    exportClients () {
      let vm = this

      let dataToSend = {
        timeZone: moment.tz.guess()
      }

      if (vm.exportClientsActive) {
        let message = {
          message: [vm.$t('private.clients.list.please_wait')],
          type: 'error'
        }

        vm.$root.$emit('showMessage', message)

        return
      }

      vm.exportClientsActive = true

      api
        .clients
        .exportClients(dataToSend)
        .then((response) => {
          vm.exportClientsActive = false

          if (response.status != 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          let file = new Blob([response.data], {type: 'application/vnd.ms-excel'})
          let fileURL = URL.createObjectURL(file)

          FileSaver.saveAs(file, 'clients.xlsx')
        })
    },
    parseDate (date) {
      return moment(date).format('DD-MM-YYYY')
    },
    resetDataMigrateClientsWindow () {
      let vm = this

      vm.migrateClientsWindow.clientsToCreated = []
      vm.migrateClientsWindow.clientsWithErrors = []
      vm.migrateClientsWindow.fields.csv.value = {}
      vm.migrateClientsWindow.fields.csv.fileReady = false
    },
    migrateClientsSubmit () {
      let vm = this

      let dataToSend = {
        separator: vm.migrateClientsWindow.fields.separator.value,
        csv: vm.migrateClientsWindow.fields.csv.value.data
      }

      vm.migrateClientsWindow.migrateCSVFileActive = true

      api
        .clients
        .migrateCSVFile('/api/clients/migrate', dataToSend)
        .then((response) => {
          vm.migrateClientsWindow.migrateCSVFileActive = false

          if (response.status != 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (!response.data.success) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          vm.migrateClientsWindow.clientsToCreated = response.data.clientsToCreated
          vm.migrateClientsWindow.clientsWithErrors = response.data.clientsWithErrors
        })
    },
    resetDataMigrateAssociatedAccountsWindow () {
      let vm = this

      vm.migrateAssociatedAccountsWindow.associateccountCreated = []
      vm.migrateAssociatedAccountsWindow.associateccountWithErrors = []
      vm.migrateAssociatedAccountsWindow.fields.csv.value = {}
      vm.migrateAssociatedAccountsWindow.fields.csv.fileReady = false
    },
    migrateAssociatedAccountsSubmit () {
      let vm = this

      let dataToSend = {
        separator: vm.migrateAssociatedAccountsWindow.fields.separator.value,
        csv: vm.migrateAssociatedAccountsWindow.fields.csv.value.data
      }

      vm.migrateAssociatedAccountsWindow.migrateCSVFileActive = true

      api
        .clients
        .migrateCSVFile('/api/clients/associatedAccounts/migrate', dataToSend)
        .then((response) => {
          vm.migrateAssociatedAccountsWindow.migrateCSVFileActive = false

          if (response.status != 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (!response.data.success) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          vm.migrateAssociatedAccountsWindow.associateccountCreated = response.data.associateccountCreated
          vm.migrateAssociatedAccountsWindow.associateccountWithErrors = response.data.associateccountWithErrors
        })
    }
  },
  components: {
    MenuMoreOptions,
    TextField,
    SelectField,
    SearchField,
    CheckboxField,
    FileField,
    DateField
  },
  created () {
    let vm = this

    vm.getClients()

    vm.searchSellers('')
  }
}



// WEBPACK FOOTER //
// ./src/components/private/clients/list/script.js